var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditProfilePhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-1048.843 -394.843)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(1048.843 394.843)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(1055.091 400.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M14.808,11.049l-3.759,3.759a.369.369,0,0,1-.485,0L.682,4.926a.586.586,0,0,1,0-.849l3.4-3.4a.586.586,0,0,1,.849,0l9.882,9.882A.284.284,0,0,1,14.808,11.049Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#e0611a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M21.976,21.532a.286.286,0,0,1-.3.3l-3.857-.059a.035.035,0,0,1-.024-.06l4.038-3.979c.01-.009.025-.006.026.007l.12,3.789",
    transform: "translate(-7.305 -7.285)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M21.976,21.532a.286.286,0,0,1-.3.3l-3.857-.059a.035.035,0,0,1-.024-.06l4.038-3.979c.01-.009.025-.006.026.007Z",
    transform: "translate(-7.305 -7.285)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    y1: 4.244,
    x2: 4.244,
    transform: "translate(2.546 2.486)",
    fill: "none",
    stroke: "#e0611a",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfilePhoto);
export default __webpack_public_path__ + "static/media/edit_profile_photo.7fc355bf402edf6b0f7807553af47b38.svg";
export { ForwardRef as ReactComponent };